module.exports = __webpack_public_path__ + "img/evidenciapp.b50de411.jpg";